export default __webpack_public_path__ + "static/media/ito-dark.6e642ab8.svg";